(function() {
  var MapBackdropApp,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  MapBackdropApp = (function() {
    function MapBackdropApp() {
      this.mergeOptions = bind(this.mergeOptions, this);
      this.setModalLocation = bind(this.setModalLocation, this);
      this.panMap = bind(this.panMap, this);
    }

    MapBackdropApp.prototype.init = function(options) {
      if (options == null) {
        options = {};
      }
      this.options = this.mergeOptions(options);
      if (L.mapbox == null) {
        console.error('Failed to load map');
        return;
      }
      L.mapbox.accessToken = 'pk.eyJ1IjoibXlmYXJtcyIsImEiOiJaY2gzXzJvIn0.Kh5pHZFlBBoMXbWMtl246A';
      this.map = L.mapbox.map('map-wrapper', 'myfarms.mcda6mi2', {
        attributionControl: false,
        zoomControl: false,
        maxBounds: [[-90, -180], [90, 180]],
        continuousWorld: false,
        dragging: false,
        touchZoom: false,
        scrollWheelZoom: false,
        doubleClickZoom: false,
        boxZoom: false,
        maxZoom: 19,
        minZoom: 2
      }).setView([44.563, -98.235], 14);
      if (this.options.useModal) {
        this.setModalLocation();
      }
      if (this.options.panMap) {
        return setTimeout((function(_this) {
          return function() {
            _this.panMap();
            return setInterval(_this.panMap, 7500);
          };
        })(this), 2000);
      }
    };

    MapBackdropApp.prototype.panMap = function() {
      var x, y;
      x = Math.max(200, Math.random() * 350);
      y = Math.max(200, Math.random() * 350);
      x = Math.random() > 0.5 ? x : x * -1;
      y = Math.random() > 0.5 ? y : y * -1;
      return this.map.panBy([x, y], {
        animate: true,
        duration: 6
      });
    };

    MapBackdropApp.prototype.setModalLocation = function() {
      var b_w, m_w;
      m_w = $('.modal').outerWidth();
      b_w = $('body').width();
      return $('.modal').css({
        'left': (b_w / 2) - (m_w / 2),
        'marginLeft': '0px',
        'top': '160px'
      });
    };

    MapBackdropApp.prototype.mergeOptions = function(options) {
      return $.extend({
        useModal: true,
        panMap: false
      }, options);
    };

    return MapBackdropApp;

  })();

  module.exports = MapBackdropApp;

}).call(this);
